import { ClipLoader } from "react-spinners";
import { FaTrash } from "react-icons/fa";

function CouponControls({
  category,
  coupons = [],
  selectedCoupons = {},
  couponInputs = {},
  couponLoading = false,
  deletingCoupon = null,
  setCouponInputs,
  handleCouponSelect,
  createCoupon,
  deleteCoupon,
}) {
  const currentInput = couponInputs?.[category] || {
    code: "",
    discount: "",
  };

  const selectedCoupon = selectedCoupons?.[category] || null;

  const updateCouponInput = (field, value) => {
    setCouponInputs((prev) => ({
      ...prev,
      [category]: {
        ...(prev?.[category] || { code: "", discount: "" }),
        [field]: value,
      },
    }));
  };

  return (
    <>
      <select onChange={(e) => handleCouponSelect(e.target.value, category)}>
        <option value="">Select Coupon</option>

        {coupons
          .filter((coupon) => coupon.category === category)
          .map((coupon) => (
            <option key={coupon.$id} value={coupon.couponCode}>
              {coupon.couponCode} - {coupon.discountPercent}%
            </option>
          ))}
      </select>

      {selectedCoupon && (
        <button
          className="delete-button"
          onClick={() => deleteCoupon(selectedCoupon.$id)}
          disabled={deletingCoupon === selectedCoupon.$id}
        >
          {deletingCoupon === selectedCoupon.$id ? (
            <ClipLoader size={12} />
          ) : (
            <FaTrash />
          )}
        </button>
      )}

      <input
        type="text"
        placeholder="New Coupon Code"
        value={currentInput.code}
        onChange={(e) => updateCouponInput("code", e.target.value)}
      />

      <input
        type="number"
        placeholder="Discount %"
        value={currentInput.discount}
        onChange={(e) => updateCouponInput("discount", e.target.value)}
      />

      <button onClick={() => createCoupon(category)} disabled={couponLoading}>
        {couponLoading ? (
          <>
            Creating.....
            <ClipLoader size={12} />
          </>
        ) : (
          "Create Coupon"
        )}
      </button>
    </>
  );
}

export default CouponControls;
